import { ThisConnector } from '../../../../api/connector'
import { getAssessRules } from '../../../assess-rules/api/requests/get-assess-rules'
import { getProtectRules } from '../../../protect-rules/api/requests/get-protect-rules'
import { BaseAssessRule } from '../../../assess-rules'
import { BaseProtectRule } from '../../../protect-rules/shared'
import { ExclusionType } from '../../../application-exclusions/exclusion-type'
import { AgentLanguageKey } from '../../../agent-language'

export interface RulesResponse {
  assessRules: BaseAssessRule[]
  protectRules: BaseProtectRule[]
}

export interface GetRulesArgs {
  organizationUuid: string
  language: AgentLanguageKey
  exclusionType: ExclusionType
  shouldLoadAssess: boolean
  shouldLoadProtect: boolean
}

export async function getRules(
  this: ThisConnector,
  {
    organizationUuid,
    language,
    exclusionType,
    shouldLoadProtect,
    shouldLoadAssess
  }: GetRulesArgs
): Promise<RulesResponse> {
  return {
    assessRules: shouldLoadAssess
      ? await getAssessRules.call(this, {
          organizationUuid,
          language,
          exclusionType
        })
      : [],
    protectRules: shouldLoadProtect
      ? await getProtectRules.call(this, {
          organizationUuid,
          language,
          exclusionType
        })
      : []
  }
}
